/* 張郃（字儁乂） */
import { defineHero, hook, U, P } from '../define.ts';

// 手短的遠距刺客：擲毒鏢，射程只有一般遠程的六成（430 → 260），要貼近才打得到
const SHORT = 170;

export default defineHero({
  id: 'zhanghe', name: '張郃', sub: '字儁乂', faction: 'wei', role: '刺客', weapon: 'sword',
  look: { dual: true, ranged: true, fx: '#b8ff9a', c: { plume: '#e0e0f0' } },
  skills: [
    ['毒霧', 'trap', '毒霧籠罩指定區域 12 秒，每秒 {15/22/29/36} 傷害。', { x: { k: 'zone', r: 200, dur: 12, dps: [15, 22, 29, 36], pal: 'poison' }, aim: P(480, 200) }],
    ['毒箭', 'buff', '開關技（按一下開啟、再按一下關閉）。開啟時毒鏢淬毒：每次普攻附毒，2 秒內每秒 {9/16/23/30} 傷害、移速 -{8/14/20/26}%，每發耗 {8/10/12/14} 氣；氣不夠時擲出普通的鏢。毒鏢射程 260，比一般遠程短。', { tg: { poison: { dps: [9, 16, 23, 30], dur: 2, slow: [8, 14, 20, 26] }, mp: [8, 10, 12, 14] }, mp: 0 }],
    ['邪惡信仰', 'passive', '每殺死一個敵人回復 {10/20/30/40} 點氣。', { pv: { manaKill: [10, 20, 30, 40] } }],
    ['劇毒標', 'bolt', '淬毒匕首造成 {70/95/120} 傷害，之後 4 秒每秒再 {30/40/50}，並短暫緩速。', { x: { k: 'nuke', dmg: [70, 95, 120], dot: { dps: [30, 40, 50], dur: 4 }, debuff: { ms: 50, dur: 2 } }, aim: U(480) }],
  ],
  hooks: [
    // 射程比一般遠程短（裝備的射程加成照樣疊上去）
    hook('recalc', 20, function (u) { if (u.spec && u.spec.id === 'zhanghe' && u.kind === 'hero') u.range -= SHORT; }),
  ],
});
